import { Link } from "react-router-dom";
import React, { useState } from "react";
import PropTypes from "prop-types";
import * as UrlHelpers from "../../libs/UrlHelpers";

LinkToDetail.propTypes = {
  material: PropTypes.object.isRequired,
};

export default function LinkToDetail({ children, material }) {
  const [path, setPath] = useState(UrlHelpers.getLinkPathForDetail(material.sMatHdrMatnr));

  function setPathDetail() {
    const newPath = UrlHelpers.getLinkPathForDetail(material.sMatHdrMatnr);
    if (newPath !== path) setPath(newPath);
  }

  return (
    <Link onMouseOver={setPathDetail} onFocus={setPathDetail} to={path}>
      {children}
    </Link>
  );
}
